import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as UploadIcon } from "../../../../../../assets/humbleicons_upload.svg";
import { useForm, Controller, useFormContext } from "react-hook-form";
import { Button } from "reactstrap";

import RHFFileUpload from "../../../../../../components/form/RHFFileUpload";


const UploadRequiredDocument = ({
  setActive,
  setTemporaryOpened

}) => {



  const { control, watch, setValue, formState: { errors }, trigger } = useFormContext();
  const type_of_claim = watch('type_of_claim');
  const travelers = watch('travelers')

  const handleNext = async () => {
    const isValid = await trigger([
      "boading_pass", "passport", 'baggage_claim', "travelers",
    ]);

    if (!isValid) {
      return;
    }

    setActive(c => c + 1);

  }

  const handleBack = () => {
    if (type_of_claim === "cancelled") {
      setActive(c => c - 2);
    } else {
      setActive(c => c - 1);

    }
  }


  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Upload required documents
        </h3>
      </div>
      <div>
        <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
          Upload the following documents for each passenger
        </h4>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
        <div className="file-a-claim">
          <h6 className="form-sub-header">
            Supported formats: PDF, DOCX, JPG. Max size: 10 MB.
          </h6>

          <div className="claim-grid">
            <RHFFileUpload
              name={`boarding_pass`}
              label="Boarding Pass"
              withDeleteButton={false}

            />

            <RHFFileUpload
              name={`passport`}
              label="Passport"
              withAsterisk={true}
              rules={{
                required: "Passport is required"
              }}
              withDeleteButton={false}

            />

            <RHFFileUpload
              name={`additional_documents`}
              label={(type_of_claim === "lost/damaged" || type_of_claim === "lost_bages") ? "Claim supporting documents and receipts" : "Additional claims documents"}
              multiple={true}

              withDeleteButton={false}

            />


            {(type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") && <RHFFileUpload
              name={`baggage_claim`}
              label="Luggage claim receipt filed in airport with the lost and found office or airline"
              withAsterisk={true}
              rules={{
                required: "Luggage claim receipt is required"
              }}
              withDeleteButton={false}

            />}
          </div>

          {travelers.length > 0 && <h4
            className="stepper-sub-header"
            style={{ marginBottom: "5px", marginTop: "30px" }}
          >
            Additional passenger
          </h4>}

          {
            travelers.length > 0 && travelers?.map((travelers, index) => {
              return (

                <div key={index}>
                  <h4 style={{ marginTop: "30px", marginBottom: "10px" }}>
                    Traveler {index + 2}
                  </h4>

                  <div className="claim-grid">
                    <RHFFileUpload
                      name={`travelers.${index}.boarding_pass`}
                      label="Boarding Pass"
                      withDeleteButton={false}

                    />

                    <RHFFileUpload
                      name={`travelers.${index}.passport`}
                      label="Passport"
                      withAsterisk={true}
                      rules={{
                        required: "Passport is required"
                      }}
                      withDeleteButton={false}

                    />

                    <RHFFileUpload
                      name={`travelers.${index}.additional_doc`}
                      label={(type_of_claim === "lost/damaged" || type_of_claim === "lost_bages") ? "Claim supporting documents and receipts" : "Additional claims documents"}


                      withDeleteButton={false}

                    />



                  </div>

                </div>
              )
            })
          }





        </div>
      </div>

      <div className="stepper-btn-wrapper">
        <button className="secondary-btn new-back-btn" type="button" onClick={handleBack} >
          Back
        </button>

        <div className="add-btn-wrapper" >

          <button className="secondary-btn" type="button" onClick={() => setTemporaryOpened(true)} >
            Temporary Save
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>




        </div>
      </div>

    </div>
  );
};

export default UploadRequiredDocument;
